import { useQuery } from '@tanstack/react-query';
import { fetchIndeedStatus } from '../api/endpoints.js';

/**
 * Site-wide reminder that the Indeed integration is running against the in-process
 * mock (no live Indeed traffic). Non-admins may be denied the status endpoint —
 * the query just errors quietly and the banner stays hidden.
 */
export function MockModeBanner() {
  const { data } = useQuery({
    queryKey: ['indeed-status'],
    queryFn: fetchIndeedStatus,
    staleTime: 60_000,
    retry: false,
  });

  if (data?.mode !== 'mock') return null;
  return (
    <div className="mock-banner" role="status">
      Indeed MOCK MODE — no live Indeed traffic
    </div>
  );
}
